/*
 * Compass Church cart page (sections/compass-main-cart.liquid).
 * Quantity and remove use /cart/change.js, then the section and the header cart
 * count are re-rendered from the current URL so totals stay in sync.
 */
(() => {
  const root = () => document.querySelector('[data-compass-cart]');

  async function refresh(message) {
    const res = await fetch(window.location.href, { headers: { Accept: 'text/html' } });
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const fresh = doc.querySelector('[data-compass-cart]');
    const current = root();
    if (fresh && current) current.replaceWith(fresh);
    const bubble = doc.getElementById('cart-icon-bubble');
    const liveBubble = document.getElementById('cart-icon-bubble');
    if (bubble && liveBubble) liveBubble.innerHTML = bubble.innerHTML;
    window.ccMapLinks?.();
    document.dispatchEvent(new CustomEvent('compass-cart:updated'));
    const status = root()?.querySelector('[data-cart-status]');
    if (status && message) status.textContent = message;
  }

  async function change(item, quantity) {
    const line = Number(item.dataset.line);
    const error = item.querySelector('[data-line-error]');
    item.classList.add('is-loading');
    item.setAttribute('aria-busy', 'true');
    error.hidden = true;
    try {
      const res = await fetch(`${window.routes?.cart_change_url || '/cart/change'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity }),
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        // Keep what the shopper typed visible and explain why it was not saved.
        item.classList.remove('is-loading');
        item.removeAttribute('aria-busy');
        error.textContent = data.description || data.message || 'That quantity could not be added.';
        error.hidden = false;
        await refresh();
        const again = root()?.querySelector(`[data-line="${line}"] [data-line-error]`);
        if (again) { again.textContent = error.textContent; again.hidden = false; }
        return;
      }
      await refresh(quantity === 0 ? 'Item removed from cart.' : 'Cart updated.');
    } catch (e) {
      item.classList.remove('is-loading');
      item.removeAttribute('aria-busy');
      error.textContent = 'Something went wrong. Please try again.';
      error.hidden = false;
    }
  }

  document.addEventListener('click', (event) => {
    const cart = event.target.closest('[data-compass-cart]');
    if (!cart) return;
    const item = event.target.closest('.ccc__item');
    if (!item || item.classList.contains('is-loading')) return;
    const input = item.querySelector('[data-qty-input]');

    const step = event.target.closest('[data-qty-change]');
    if (step) {
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.dataset.qtyChange));
      input.value = next;
      change(item, next);
      return;
    }
    if (event.target.closest('[data-remove]')) change(item, 0);
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-compass-cart] [data-qty-input]')) {
      const item = event.target.closest('.ccc__item');
      change(item, Math.max(0, parseInt(event.target.value, 10) || 0));
    }
  });

  // Save the order note as the shopper types (the checkout button also submits it).
  let noteTimer;
  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-compass-cart] [data-cart-note]')) return;
    clearTimeout(noteTimer);
    const note = event.target.value;
    noteTimer = setTimeout(() => {
      fetch(`${window.routes?.cart_update_url || '/cart/update'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note }),
      });
    }, 400);
  });

  // Show the pinned checkout bar only while the main checkout button is off-screen.
  let observer;
  function watchCheckout() {
    observer?.disconnect();
    const main = document.querySelector('[data-compass-cart] [data-main-checkout]');
    const bar = document.querySelector('[data-compass-cart] [data-checkout-bar]');
    if (!main || !bar || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top > 0;
      bar.hidden = !show;
      bar.setAttribute('aria-hidden', String(!show));
      bar.querySelector('button').tabIndex = show ? 0 : -1;
    });
    observer.observe(main);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCheckout);
  else watchCheckout();
  document.addEventListener('compass-cart:updated', watchCheckout);

  // Enter in a quantity box updates that line instead of going to checkout.
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && event.target.matches('[data-compass-cart] [data-qty-input]')) {
      event.preventDefault();
      event.target.blur();
    }
  });
})();
